module.exports = __webpack_public_path__ + "static/media/image-6.124471b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-6.jpg
// module id = 259
// module chunks = 0